<div class="min-h-screen flex flex-col md:flex-row bg-[#f9fafb]">
    <div class="relative flex justify-center w-full px-2 pt-4 md:p-0 md:block md:w-auto">
        <div class="flex md:justify-center w-full md:w-64 bg-white border-r border-gray-200 p-6 md:h-screen rounded-2xl md:rounded-none overflow-hidden md:overflow-auto lg:block lg:sticky lg:top-0">
            <app-main-sidenav
            *ngIf="selectedJob?.jobForm?.jobFormSections as steps"
            [stepsList]="steps"
            (selectedStep)="setSelectedStep($event)">
            </app-main-sidenav>
        </div>
    </div>

    <div class="flex justify-center w-full p-2 md:p-8 pt-2 md:pt-8 relative">
        <mat-spinner *ngIf="isLoading" class="z-10 top-[200px]" [diameter]="60"></mat-spinner>

        <app-welcome *ngIf="_applyJobStepperStatusService.jobSteps[0] && _applyJobStepperStatusService.jobSteps[0].isSelected" (goToNextStep)="loadFirstFormStep()"></app-welcome>

        <!-- Preview Form -->
         <div *ngIf="_applyJobStepperStatusService.activeJobStep > 0 && _applyJobStepperStatusService.jobSteps[_applyJobStepperStatusService.activeJobStep].isSelected" class="max-w-[1200px] w-full bg-gradient-to-br from-gray-50 via-white to-gray-50 rounded-2xl shadow-lg border border-gray-200/50 backdrop-blur-xl p-10">
            <div class="pb-10" *ngIf="!_applyJobStepperStatusService.jobSteps[_applyJobStepperStatusService.activeJobStep].isDefault">
              <div class="flex items-center justify-center w-full pt-0">
                <div class="w-full h-full" (click)="$event.stopPropagation()">

                  <div *ngIf="jobSectionTitle">
                    <h2 class="mb-2 text-2xl font-bold text-gray-900 font-['Outfit-bold']">
                      {{ jobSectionTitle }}
                    </h2>
                  </div>

                  <div *ngIf="jobSectionDescription">
                    <h2 class="mt-0 mb-8 text-1xl text-gray-500 font-['Outfit']">
                      {{ jobSectionDescription }}
                    </h2>
                  </div>

                  <form [formGroup]="dynamicForm" class="grid grid-cols-1 md:grid-cols-1 gap-0">
                    <div *ngFor="let field of jobSectionProperties" class="relative">
                      <label *ngIf="field.type != 'video' && field.type != 'file'" class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                        {{ field.label }}
                        <span *ngIf="field.required" class="text-red-500">*</span>
                      </label>

                      <div [ngSwitch]="field.type">
                        <!-- Text / Email / Number / Phone -->
                        <input *ngSwitchCase="'text'"
                              type="text"
                              [formControlName]="field.label"
                              [placeholder]="field.placeHolder || ''"
                              class="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" />

                        <input *ngSwitchCase="'email'"
                              type="email"
                              [formControlName]="field.label"
                              [placeholder]="field.placeHolder || ''"
                              class="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" />

                        <input *ngSwitchCase="'phone'"
                              type="tel"
                              [formControlName]="field.label"
                              [placeholder]="field.placeHolder || ''"
                              class="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                              (input)="formatPhone($event)" />

                        <input *ngSwitchCase="'number'"
                              type="number"
                              [formControlName]="field.label"
                              [placeholder]="field.placeHolder || ''"
                              class="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" />

                        <!-- Experience -->
                        <textarea *ngSwitchCase="'about-textarea'"
                                  [formControlName]="field.label"
                                  [placeholder]="field.placeHolder || ''"
                                  rows="3"
                                  class="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"></textarea>

                        <!-- Textarea -->
                        <textarea *ngSwitchCase="'textarea'"
                                  [formControlName]="field.label"
                                  [placeholder]="field.placeHolder || ''"
                                  rows="3"
                                  class="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"></textarea>

                        <!-- Select -->
                        <select *ngSwitchCase="'select'"
                                [formControlName]="field.label"
                                class="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500">
                          <option value="">{{ field.placeHolder || 'Select an option' }}</option>
                          <option *ngFor="let option of field.options" [value]="option">{{ option }}</option>
                        </select>

                        <!-- Checkbox -->
                        <div *ngSwitchCase="'checkbox'" class="space-y-2">
                          <label *ngFor="let option of field.options" class="flex items-center space-x-2">
                            <input type="checkbox"
                                  [formControlName]="field.label + '_' + option"
                                  class="rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                            <span>{{ option }}</span>
                          </label>
                        </div>

                        <!-- Radio -->
                        <div *ngSwitchCase="'radio'" class="space-y-6">
                          <div class="grid grid-cols-2 gap-4">
                            <button *ngFor="let option of field.options"
                                    type="button"
                                    (click)="dynamicForm.controls[field.label].setValue(option)"
                                    [ngClass]="[
                                      'flex items-center justify-center px-6 py-4 border rounded-lg transition-colors',
                                      dynamicForm.controls[field.label].value === option && option.toLowerCase() === 'no'
                                        ? 'border-red-300 bg-red-50'
                                        : dynamicForm.controls[field.label].value === option
                                          ? 'border-green-300 bg-green-50'
                                          : 'border-gray-300 hover:border-blue-300'
                                    ]">
                              <svg *ngIf="dynamicForm.controls[field.label].value === option" class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
                                <path fill-rule="evenodd"
                                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                      clip-rule="evenodd"></path>
                              </svg>
                              <span>{{ option }}</span>
                            </button>
                          </div>
                        </div>

                        <!-- Date -->
                        <input *ngSwitchCase="'date'"
                              type="date"
                              [formControlName]="field.label"
                              class="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500" />

                        <!-- File -->
                        <input type="hidden" name="application_id" value="31beef27-6beb-4bda-9ba6-c41ddf1861e3">

                        <div class="space-y-8" *ngSwitchCase="'file'">
                          <div>
                            <!-- <h2 class="text-2xl font-bold text-gray-900 mb-2 font-['Outfit-bold']">{{ 'JOB_APPLICATIONS.ADD_PHOTO_TITLE' | translate }}</h2>
                            <p class="text-gray-600 mb-8 font-['Outfit']">{{ 'JOB_APPLICATIONS.ADD_PHOTO_DESC' | translate }}</p> -->

                            <div class="flex flex-col items-center">
                              <!-- Clickable upload container -->
                              <div
                                class="cursor-pointer w-64 h-64 border-2 border-dashed border-gray-300 hover:border-gray-400 rounded-full flex flex-col items-center justify-center mb-6 overflow-hidden"
                                (click)="photoInput.click()"
                              >
                                <!-- Display uploaded image if exists -->
                                <img *ngIf="photoURL" [src]="photoURL" class="w-full h-full object-cover rounded-full" />

                                <!-- Show placeholder if no image -->
                                <ng-container *ngIf="!photoURL">
                                  <svg class="w-12 h-12 text-gray-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"></path>
                                  </svg>
                                  <p class="text-gray-500 text-center">
                                    <span class="font-medium font-['Outfit']">{{ 'JOB_APPLICATIONS.CLICK_TO_UPLOAD' | translate }}</span>
                                  </p>
                                </ng-container>
                              </div>

                              <!-- Hidden file input -->
                              <input
                                type="file"
                                #photoInput
                                accept="image/*"
                                (change)="onPhotoSelected($event)"
                                class="hidden"
                              />
                            </div>
                          </div>
                        </div>

                        <!-- Video -->
                        <div *ngSwitchCase="'video'">
                          <app-video (recordedVideo)="setRecordedVideo($event)" [buttonAction]="_applyJobStepperStatusService.jobSteps.length - 1 == _applyJobStepperStatusService.activeJobStep ? 'submit' : 'continue'" (buttonActionClicked)="selectedVideoButton($event)" [loading]="isLoading"></app-video>
                        </div>

                        <div *ngSwitchCase="'tags'" class="space-y-2">
                          <div class="w-full pl-[10px] pr-[10px]">
                            <!-- Selected count -->
                            <div class="mb-8">
                              <div class="mt-4 flex items-center gap-2">
                                <div class="flex gap-1">
                                  <div class="w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-300 scale-100" [ngClass]="dynamicForm.get(field.label)?.value?.length >= 1 ? 'bg-blue-600 text-white' : 'bg-slate-200 text-slate-400'">
                                    1
                                  </div>
                                  <div class="w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-300 scale-100" [ngClass]="dynamicForm.get(field.label)?.value?.length >= 2 ? 'bg-blue-600 text-white' : 'bg-slate-200 text-slate-400'">
                                    2
                                  </div>
                                  <div class="w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold transition-all duration-300 scale-100" [ngClass]="dynamicForm.get(field.label)?.value?.length >= 3 ? 'bg-blue-600 text-white' : 'bg-slate-200 text-slate-400'">
                                    2
                                  </div>
                                </div>
                                <span class="text-slate-500 text-sm ml-2">
                                  {{ dynamicForm.get(field.label)?.value?.length || 0 }}/3 selected
                                </span>
                              </div>
                            </div>

                            <!-- Buttons grid -->
                            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
                              <button
                                *ngFor="let option of field.options"
                                type="button"
                                (click)="toggleTag(field.label, option)"
                                [ngClass]="
                                  isTagSelected(field.label, option)
                                    ? 'border-blue-600 bg-blue-50 shadow-md scale-[1.02]'
                                    : 'border-slate-200 bg-slate-50'
                                "
                                class="relative group px-5 py-4 rounded-xl border-2 text-left transition-all duration-200"
                                [disabled]="
                                  !isTagSelected(field.label, option) &&
                                  (dynamicForm.get(field.label)?.value?.length || 0) >= 3
                                "
                              >
                                <div class="flex items-center justify-between">
                                  <span
                                    [ngClass]="
                                      isTagSelected(field.label, option)
                                        ? 'text-blue-900 font-medium'
                                        : 'text-slate-700 font-medium'
                                    "
                                  >
                                    {{ option }}
                                  </span>
                                  <div
                                    *ngIf="isTagSelected(field.label, option)"
                                    class="w-6 h-6 bg-blue-600 rounded-full flex items-center justify-center animate-in zoom-in duration-200"
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="24"
                                      height="24"
                                      viewBox="0 0 24 24"
                                      fill="none"
                                      stroke="currentColor"
                                      stroke-width="3"
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      class="lucide lucide-check w-4 h-4 text-white"
                                    >
                                      <path d="M20 6 9 17l-5-5"></path>
                                    </svg>
                                  </div>
                                </div>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Validation message -->
                      <p [ngClass]="{'opacity-0' : !dynamicForm.controls[field.label]?.touched || !dynamicForm.controls[field.label]?.invalid}"
                        class="text-red-500 text-sm mt-1 font-['Outfit-medium']">
                        {{ field.label }} is required or invalid
                      </p>

                    </div>
                  </form>
                </div>
              </div>

              <div class="flex mt-8 pt-6 border-t border-gray-200 justify-end" *ngIf="!isVideoStep()">
                <button *ngIf="_applyJobStepperStatusService.activeJobStep < _applyJobStepperStatusService.jobSteps.length - 1 && !isVideoStep()" class="px-8 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors flex items-center font-['Outfit']" [disabled]="!isCurrentStepValid()" (click)="onContinueStep()">
                  {{ 'JOB_APPLICATIONS.CONTINUE' | translate }}
                  <svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                  </svg>
                </button>

                <button (click)="submitForm()" *ngIf="_applyJobStepperStatusService.jobSteps.length - 1 == _applyJobStepperStatusService.activeJobStep && !isVideoStep()" class="px-8 py-3 bg-green-500 text-white rounded-lg hover:bg-blue-600 transition-colors flex items-center font-['Outfit']">
                  {{ 'JOB_APPLICATIONS.SUBMIT_APPLICATION' | translate }}
                  <svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                  </svg>
                </button>
              </div>
            </div>

            <!-- Basic Info Default -->
            <div class="space-y-8" *ngIf="_applyJobStepperStatusService.jobSteps[_applyJobStepperStatusService.activeJobStep].isDefault" [formGroup]="form">
                <div>
                <h2 class="text-2xl font-bold text-gray-900 mb-6 font-['Outfit-bold']">
                    {{ 'JOB_APPLICATIONS.TITLE' | translate }}
                </h2>
                <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                    <!-- First Name -->
                    <div class="relative">
                    <label class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                        {{ 'JOB_APPLICATIONS.FIRST_NAME' | translate }}
                    </label>
                    <input
                        type="text"
                        formControlName="firstName"
                        placeholder="{{ 'JOB_APPLICATIONS.FIRST_NAME_PLACEHOLDER' | translate }}"
                        class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                    <p *ngIf="f['firstName'].touched && f['firstName'].invalid" class="absolute text-red-500 text-sm font-['Outfit'] mt-1">
                        {{ 'JOB_APPLICATIONS.FIRST_NAME_REQUIRED' | translate }}
                    </p>
                    </div>

                    <!-- Last Name -->
                    <div class="relative">
                    <label class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                        {{ 'JOB_APPLICATIONS.LAST_NAME' | translate }}
                    </label>
                    <input
                        type="text"
                        formControlName="lastName"
                        placeholder="{{ 'JOB_APPLICATIONS.LAST_NAME_PLACEHOLDER' | translate }}"
                        class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                    <p *ngIf="f['lastName'].touched && f['lastName'].invalid" class="absolute text-red-500 text-sm mt-1">
                        {{ 'JOB_APPLICATIONS.LAST_NAME_REQUIRED' | translate }}
                    </p>
                    </div>

                    <!-- Email -->
                    <div class="relative">
                    <label class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                        {{ 'JOB_APPLICATIONS.EMAIL' | translate }}
                    </label>
                    <div class="relative">
                        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <!-- Icon -->
                        <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                            />
                        </svg>
                        </div>
                        <input
                        type="email"
                        formControlName="email"
                        placeholder="{{ 'JOB_APPLICATIONS.EMAIL_PLACEHOLDER' | translate }}"
                        class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        />
                    </div>
                    <p *ngIf="f['email'].touched && f['email'].errors?.['required']" class="absolute text-red-500 text-sm mt-1">
                        {{ 'JOB_APPLICATIONS.EMAIL_REQUIRED' | translate }}
                    </p>
                    <p *ngIf="f['email'].touched && f['email'].errors?.['email']" class="absolute text-red-500 text-sm mt-1">
                        {{ 'JOB_APPLICATIONS.EMAIL_INVALID' | translate }}
                    </p>
                    </div>

                    <!-- Phone -->
                    <div class="relative">
                    <label class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                        {{ 'JOB_APPLICATIONS.PHONE' | translate }}
                    </label>
                    <div class="relative">
                        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <!-- Icon -->
                        <svg class="h-5 w-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                            />
                        </svg>
                        </div>
                        <input
                        (input)="formatPhone($event)"
                        type="tel"
                        formControlName="phone"
                        placeholder="{{ 'JOB_APPLICATIONS.PHONE_PLACEHOLDER' | translate }}"
                        maxlength="12"
                        class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        />
                    </div>
                    <p *ngIf="f['phone'].touched && f['phone'].errors?.['required']" class="absolute text-red-500 text-sm mt-1">
                        {{ 'JOB_APPLICATIONS.PHONE_REQUIRED' | translate }}
                    </p>
                    <p *ngIf="f['phone'].touched && f['phone'].errors?.['pattern']" class="absolute text-red-500 text-sm mt-1">
                        {{ 'JOB_APPLICATIONS.PHONE_INVALID' | translate }}
                    </p>
                    </div>
                </div>

                <!-- Address -->
                <div class="mt-8">
                    <h3 class="text-lg font-semibold text-gray-900 mb-4 font-['Outfit-medium']">
                    {{ 'JOB_APPLICATIONS.ADDRESS' | translate }}
                    </h3>
                    <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
                    <!-- Street Address -->
                    <div class="md:col-span-3 relative">
                        <label class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                        {{ 'JOB_APPLICATIONS.STREET_ADDRESS' | translate }}
                        </label>
                        <div class="relative">
                        <input
                            type="text"
                            formControlName="streetAddress"
                            placeholder="{{ 'JOB_APPLICATIONS.STREET_PLACEHOLDER' | translate }}"
                            class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        />
                        </div>
                        <p *ngIf="f['streetAddress'].touched && f['streetAddress'].invalid" class="absolute text-red-500 text-sm mt-1">
                        {{ 'JOB_APPLICATIONS.STREET_REQUIRED' | translate }}
                        </p>
                    </div>

                    <!-- Apt/Suite -->
                    <div class="relative">
                        <label class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                        {{ 'JOB_APPLICATIONS.APT_SUITE' | translate }}
                        </label>
                        <input
                        type="text"
                        formControlName="aptSuite"
                        placeholder="{{ 'JOB_APPLICATIONS.APT_PLACEHOLDER' | translate }}"
                        class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        />
                    </div>
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 mt-8">
                    <!-- City -->
                    <div class="relative">
                        <label class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                        {{ 'JOB_APPLICATIONS.CITY' | translate }}
                        </label>
                        <input
                        type="text"
                        formControlName="city"
                        placeholder="{{ 'JOB_APPLICATIONS.CITY_PLACEHOLDER' | translate }}"
                        class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        />
                        <p *ngIf="f['city'].touched && f['city'].invalid" class="absolute text-red-500 text-sm mt-1">
                        {{ 'JOB_APPLICATIONS.CITY_REQUIRED' | translate }}
                        </p>
                    </div>

                    <!-- State -->
                    <div class="relative">
                        <label class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                        {{ 'JOB_APPLICATIONS.STATE' | translate }}
                        </label>
                        <select
                        formControlName="state"
                        class="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none"
                        >
                        <option value="">{{ 'JOB_APPLICATIONS.STATE_PLACEHOLDER' | translate }}</option>

                        <optgroup label="United States">
                          <option value="AL">Alabama</option>
                          <option value="AK">Alaska</option>
                          <option value="AZ">Arizona</option>
                          <option value="AR">Arkansas</option>
                          <option value="CA">California</option>
                          <option value="CO">Colorado</option>
                          <option value="CT">Connecticut</option>
                          <option value="DE">Delaware</option>
                          <option value="FL">Florida</option>
                          <option value="GA">Georgia</option>
                          <option value="HI">Hawaii</option>
                          <option value="ID">Idaho</option>
                          <option value="IL">Illinois</option>
                          <option value="IN">Indiana</option>
                          <option value="IA">Iowa</option>
                          <option value="KS">Kansas</option>
                          <option value="KY">Kentucky</option>
                          <option value="LA">Louisiana</option>
                          <option value="ME">Maine</option>
                          <option value="MD">Maryland</option>
                          <option value="MA">Massachusetts</option>
                          <option value="MI">Michigan</option>
                          <option value="MN">Minnesota</option>
                          <option value="MS">Mississippi</option>
                          <option value="MO">Missouri</option>
                          <option value="MT">Montana</option>
                          <option value="NE">Nebraska</option>
                          <option value="NV">Nevada</option>
                          <option value="NH">New Hampshire</option>
                          <option value="NJ">New Jersey</option>
                          <option value="NM">New Mexico</option>
                          <option value="NY">New York</option>
                          <option value="NC">North Carolina</option>
                          <option value="ND">North Dakota</option>
                          <option value="OH">Ohio</option>
                          <option value="OK">Oklahoma</option>
                          <option value="OR">Oregon</option>
                          <option value="PA">Pennsylvania</option>
                          <option value="RI">Rhode Island</option>
                          <option value="SC">South Carolina</option>
                          <option value="SD">South Dakota</option>
                          <option value="TN">Tennessee</option>
                          <option value="TX">Texas</option>
                          <option value="UT">Utah</option>
                          <option value="VT">Vermont</option>
                          <option value="VA">Virginia</option>
                          <option value="WA">Washington</option>
                          <option value="WV">West Virginia</option>
                          <option value="WI">Wisconsin</option>
                          <option value="WY">Wyoming</option>
                        </optgroup>
  
                        <optgroup label="Canada">
                          <option value="AB">Alberta</option>
                          <option value="BC">British Columbia</option>
                          <option value="MB">Manitoba</option>
                          <option value="NB">New Brunswick</option>
                          <option value="NL">Newfoundland and Labrador</option>
                          <option value="NT">Northwest Territories</option>
                          <option value="NS">Nova Scotia</option>
                          <option value="NU">Nunavut</option>
                          <option value="ON">Ontario</option>
                          <option value="PE">Prince Edward Island</option>
                          <option value="QC">Quebec</option>
                          <option value="SK">Saskatchewan</option>
                          <option value="YT">Yukon</option>
                        </optgroup>
                        </select>
                        <p *ngIf="f['state'].touched && f['state'].invalid" class="absolute text-red-500 text-sm mt-1">
                        {{ 'JOB_APPLICATIONS.STATE_REQUIRED' | translate }}
                        </p>
                    </div>

                    <!-- ZIP -->
                    <div class="relative">
                        <label class="block text-sm font-medium text-gray-700 mb-2 font-['Outfit-medium']">
                        {{ 'JOB_APPLICATIONS.ZIP' | translate }}
                        </label>
                        <input
                        type="text"
                        formControlName="zip"
                        placeholder="{{ 'JOB_APPLICATIONS.ZIP_PLACEHOLDER' | translate }}"
                        class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                        />
                        <p *ngIf="f['zip'].touched && f['zip'].invalid" class="absolute text-red-500 text-sm mt-1">
                        {{ 'JOB_APPLICATIONS.ZIP_REQUIRED' | translate }}
                        </p>
                    </div>
                    </div>
                </div>
                </div>

                <!-- Submit -->
                <div class="flex mt-8 pt-6 border-t border-gray-200 justify-end">
                <button (click)="onContinueStep()" [disabled]="form.invalid"
                    type="submit"
                    class="px-8 py-3 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors flex items-center font-['Outfit-medium']"
                >
                    {{ 'JOB_APPLICATIONS.CONTINUE' | translate }}
                    <svg class="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                    </svg>
                </button>
                </div>
            </div>
         </div>
    </div>
</div>